/**
 * Tela única de login (21/09/2026). As três rotas antigas continuam existindo
 * como constantes porque mais de 50 arquivos as chamam — no `App.tsx` elas viram
 * `<Navigate>` para `/entrar` com o perfil certo pré-selecionado (ADR 0010).
 */
export const LOGIN_UNIFICADO = () => `/entrar`;

export const LOGINPAGE = () => `/login`;
export const FREELANCER_LOGIN_PAGE = () => `/freelancer-login`;
export const LOGIN_CHOICE = () => `/login-choice`;
